import { t } from 'i18next';
import {
  NODE_CATEGORIES,
  NODE_TYPES,
  STAGE_TYPE_IDS,
} from '../../../../../constants/workflow.constant';
import { getNodeFormIds } from '../utils/graphHelpers';

export const validateStageRequirements = (nodes, edges) => {
  const submissionNodes = nodes.filter(
    (node) => node.category === NODE_CATEGORIES.SUBMISSION
  );
  const reviewNodes = nodes.filter(
    (node) => node.category === NODE_CATEGORIES.REVIEW
  );

  if (submissionNodes.length === 0 || reviewNodes.length === 0) {
    return {
      message: t('workflowValidation.bothSubmissionAndReviewRequired'),
    };
  }

  for (const submissionNode of submissionNodes) {
    const submissionName =
      submissionNode.data?.formConfig?.name || submissionNode.id;
    const outgoingEdges = edges.filter(
      (edge) => edge.source === submissionNode.id
    );

    if (outgoingEdges.length === 0) {
      return {
        message: t('workflowValidation.submissionNodeOutgoingConnection', {
          name: submissionName,
        }),
      };
    }
  }

  return null;
};

export const validateNodeConfiguration = (nodes) => {
  const formStageNodes = nodes.filter(
    (node) => node.type === NODE_TYPES.FORM_STAGE
  );

  for (const node of formStageNodes) {
    const config = node.data?.formConfig || {};
    const name = node.data?.name;
    const stageTypeId = config.stage_type_id;

    if (!name || !name.trim()) {
      return {
        message: t('workflowValidation.stageNameRequired'),
      };
    }

    if (!stageTypeId) {
      return {
        message: t('workflowValidation.stageTypeRequired', { name }),
      };
    }

    if (
      stageTypeId === STAGE_TYPE_IDS.SUBMISSION ||
      stageTypeId === STAGE_TYPE_IDS.REVIEW
    ) {
      const formIds = getNodeFormIds(node);
      if (formIds.length === 0) {
        return {
          message: t('workflowValidation.stageFormRequired', { name }),
        };
      }
    }

    if (stageTypeId === STAGE_TYPE_IDS.REVIEW) {
      if (!config.approver_role_id) {
        return {
          message: t('workflowValidation.reviewApproverRequired', { name }),
        };
      }
    }

    if (stageTypeId === STAGE_TYPE_IDS.SUBMISSION) {
      if (!config.target_category_id) {
        return {
          message: t('workflowValidation.submissionTargetCategoryRequired', {
            name,
          }),
        };
      }
    }
  }

  return null;
};
